module.exports = __webpack_public_path__ + "static/caucus-primary-daily-struggle-70acbd84f2a04b689b88ba3d7ae4a73f.png";